import Bank from '@/api/bank'

export default {
  fetch: ({ commit }) => {
    commit('changeLoading', { isLoading: true })
    return Bank.wallet()
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('updateWallet', { wallet: data })
      })
      .catch(error => {
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  transfer: ({ commit, dispatch }, { amount, currency, reference }) => {
    commit('changeLoading', { isLoading: true })
    return Bank.transfer({ amount, currency, reference })
      .then(({ data }) => dispatch('fetch'))
      .catch(err => {
        commit('changeLoading', { isLoading: false })
        throw err
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/wallets/actions.js